import React, { FC } from 'react';
import { StyledBox } from './styled';
import { IBoxProps } from './typed';

const Box: FC<IBoxProps> = ({ children, type }) => {
  return <StyledBox type={type}>{children}</StyledBox>;
};

export default Box;
